import { boxShadow, createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  sectionWrapper: {
    pt: '-30px',
  },
  documentWrapper: {
    maxWidth: '898px',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    padding: '24px',
    gap: '24px',
    width: '100%',
    borderRadius: '12px',
    textDecoration: 'none',
    boxShadow: boxShadow.O3,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  image: {
    minWidth: '56px',
    height: '56px',
    width: '56px',
    borderRadius: '50%',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    maxWidth: '100%',
  },
  chip: {
    padding: '4px 8px',
    borderRadius: '4px',
    backgroundColor: 'custom.menuItemHover',
  },
  title: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'start', md: 'center' },
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'fit-content',
  },
  authorImage: {
    borderRadius: '8px',
    height: {
      xs: '300px',
      sm: '160px',
    },
    minWidth: '250px',
    width: {
      xs: '100%',
      sm: 'unset',
    },

    img: {
      maxHeight: '100%',
      minHeight: '100%',
      maxWidth: '100%',
      minWidth: '100%',
    },
  },
  authorHeader: {
    display: 'flex',
    gap: '8px',
    alignItems: {
      xs: '',
      sm: 'center',
    },
  },
  authorName: {},
  profileButton: {
    color: 'primary.main',
    maxHeight: '20px',
    '& .MuiSvgIcon-root': {
      color: 'currentColor !important',
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
      background: 'inherit',
    },
    padding: '0px !important',
  },
  authorDescription: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
  socialImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '1px',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
